// extracted by mini-css-extract-plugin
module.exports = {"inputGroup":"InputGroup_inputGroup__NWDQT"};